export default __webpack_public_path__ + "static/media/quzilla_logo_1c_black.42bbb674.png";